import React from "react";
import { Link } from "react-router-dom";

export const NewBreadcrumbs = props => <div className="d-flex justify-content-between align-items-center mb-1"><ol className="breadcrumbs">
  {props.crumbs.map(link => {
    return <li><Link to={link.link}>{link.label}</Link></li>
  })}
  <li>{props.current}</li>
</ol>
</div>
